import React, { useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord, faYoutube, faSpotify, faInstagram, faGithub, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { motion } from 'framer-motion';
import './SocialIcons.css';

const socialLinks = [
  { icon: faDiscord, url: 'https://discord.gg/KnBJMccvfz', tooltip: '@miquellakami', name: 'discord' },
  { icon: faXTwitter, url: 'https://x.com/miquelladesu', tooltip: '@miquelladesu', name: 'twitter' },
  { icon: faYoutube, url: 'https://www.youtube.com/@miquelladesu', tooltip: '@miquelladesu', name: 'youtube' },
  { icon: faSpotify, url: 'https://open.spotify.com/user/31dg4b7t5mvebnzbjzuzn7c77oge?si=5c90da68000c447e', tooltip: '@miquelladesu', name: 'spotify' },
  { icon: faInstagram, url: 'https://www.instagram.com/miquelladesu/', tooltip: '@miquelladesu', name: 'instagram' },
  { icon: faGithub, url: 'https://github.com/miquelladesu', tooltip: '@miquelladesu', name: 'github' },
];

const SocialIcons = ({ videoPlaying }) => {
  const [activeIcon, setActiveIcon] = useState(null); // Track active icon for transition
  const [copySuccess, setCopySuccess] = useState(false); // Show copy notification

  const handleLeftClick = useCallback((url, name) => {
    setActiveIcon(name); // Trigger animation for the clicked icon
    setTimeout(() => {
      window.open(url, '_blank'); // Redirect to social link
      setActiveIcon(null); // Reset after redirection
    }, 1500); // Delay for animation effect
  }, []);

  const handleRightClick = useCallback((e, tooltip) => {
    e.preventDefault(); // Prevent the context menu from opening
    navigator.clipboard.writeText(tooltip).then(() => {
      setCopySuccess(true); // Show "copied" notification
      setTimeout(() => setCopySuccess(false), 2000); // Hide notification after 2 seconds
    });
  }, []);

  return (
    <div className={`social-icons ${videoPlaying ? 'video-mode' : ''}`}>
      {socialLinks.map(({ icon, url, tooltip, name }) => (
        <motion.div
          key={name}
          className={`icon-container ${activeIcon === name ? 'clicked' : ''}`}
          onContextMenu={(e) => handleRightClick(e, tooltip)}
        >
          <button
            onClick={() => handleLeftClick(url, name)}
            aria-label={`Visit my ${name} page`}
          >
            <FontAwesomeIcon icon={icon} />
          </button>
        </motion.div>
      ))}

      {/* Copy notification */}
      {copySuccess && (
        <motion.div
          className="copy-notification"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.5 }}
        >
          Username copied!
        </motion.div>
      )}
    </div>
  );
};

export default SocialIcons;
